// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 20px 20px;
  background: white;
  margin: 0;
}

.title {
  font-family: AppFontBold, sans-serif;
  font-size: 28px;
  line-height: 35px;
  letter-spacing: 0.06em;
  text-align: center;
  color: var(--ion-color-secondary);
  margin-bottom: 8px;
}

.info {
  font-family: AppFontLight;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.02em;
  text-align: center;
  color: var(--ion-color-secondary);
  margin-bottom: 25px;
}

.button {
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}
.button:last-child {
  margin-bottom: 0;
}
.button_main {
  background: var(--ion-color-primary);
  font-family: AppFontBold, sans-serif;
  font-size: 20px;
  line-height: 25px;
  letter-spacing: 0.06em;
  text-align: center;
  color: white;
  border-radius: 16px;
}
.button_close {
  background: transparent;
  font-family: AppFontBold, sans-serif;
  border-radius: 16px;
  font-size: 20px;
  line-height: 25px;
  letter-spacing: 0.06em;
  text-align: center;
  border: 1px solid #ED6958;
  border-radius: 16px;
  color: #ED6958;
}`, "",{"version":3,"sources":["webpack://./src/app/components/info-modal/info-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,SAAA;AACF;;AAEA;EACE,oCAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;EACA,kBAAA;AACF;;AAEA;EACE,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AACF;AACE;EACE,gBAAA;AACJ;AAEE;EACE,oCAAA;EACA,oCAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AAAJ;AAGE;EACE,uBAAA;EAEA,oCAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;AAFJ","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 30px 20px 20px;\n  background: white;\n  margin: 0;\n}\n\n.title {\n  font-family: AppFontBold, sans-serif;\n  font-size: 28px;\n  line-height: 35px;\n  letter-spacing: 0.06em;\n  text-align: center;\n  color: var(--ion-color-secondary);\n  margin-bottom: 8px;\n}\n\n.info {\n  font-family: AppFontLight;\n  font-size: 16px;\n  line-height: 19px;\n  letter-spacing: 0.02em;\n  text-align: center;\n  color: var(--ion-color-secondary);\n  margin-bottom: 25px;\n}\n\n.button {\n  height: 60px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 10px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  &_main {\n    background: var(--ion-color-primary);\n    font-family: AppFontBold, sans-serif;\n    font-size: 20px;\n    line-height: 25px;\n    letter-spacing: 0.06em;\n    text-align: center;\n    color: white;\n    border-radius: 16px;\n  }\n\n  &_close {\n    background: transparent;\n\n    font-family: AppFontBold, sans-serif;\n    border-radius: 16px;\n    font-size: 20px;\n    line-height: 25px;\n    letter-spacing: 0.06em;\n    text-align: center;\n    border: 1px solid #ED6958;\n    border-radius: 16px;\n    color: #ED6958;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
